@if (maintenance) {
  <app-maintenance></app-maintenance>
} @else if (appReady()) {
  <mat-sidenav-container>
    <mat-sidenav
      #sidenav
      [position]="sidenavPosition()"
      fixedInViewport="true"
      autoFocus="false"
    >
      @switch (currentSidenav()) {
        @case (Sidenavs.Header) {
          <app-header-sidenav (signOut)="onSignOut()"></app-header-sidenav>
        }
        @case (Sidenavs.Search) {
          <app-event-search></app-event-search>
        }
        @case (Sidenavs.Plp) {
          <app-plp-filter-sidenav></app-plp-filter-sidenav>
        }
        @case (Sidenavs.CustomizeLook) {
          <app-customize-look-filter-sidenav></app-customize-look-filter-sidenav>
        }
      }
    </mat-sidenav>
    <mat-sidenav-content id="matSideNavContent">
      <header [class.mobile]="isMobile()">
        <app-header [isMobile]="isMobile()"></app-header>
      </header>
      <main [class.full-screen]="isFullScreen()" [class.mobile]="isMobile()">
        <!-- DO NOT DELETE - search drawer will be reenabled in future -->
        <!-- <mat-drawer-container>
            @if (firebaseUser()?.emailVerified) {
              <mat-drawer
                opened
                mode="side"
                [ngStyle]="{
                  'width.px': drawerWidth(),
                  display: isMobile() ? 'none' : 'initial',
                }"
              >
                @if (!isMobile()) {
                  <app-event-search></app-event-search>
                }
              </mat-drawer>
            }
            <mat-drawer-content [ngStyle]="{ 'margin-left.px': drawerWidth() }"> -->
        <router-outlet></router-outlet>
        <!-- </mat-drawer-content>
          </mat-drawer-container> -->
      </main>
      @if (impersonationMode()) {
        <jfw-impersonation-bar
          [signedInAsEmail]="firebaseUser()?.email"
          [impersonatorEmail]="impersonatingUser()?.email"
          [timeLeft]="impersonationTimeLeft()"
          (exit)="onExitImpersonation()"
        ></jfw-impersonation-bar>
      }
    </mat-sidenav-content>
  </mat-sidenav-container>
  @if (accountSwitching()) {
    <ng-container
      [ngTemplateOutlet]="loadingScreen"
      [ngTemplateOutletContext]="{
        overlay: true,
        stepIndex: 2,
        label: switchingLabel,
      }"
    ></ng-container>
  }
} @else {
  <ng-container
    [ngTemplateOutlet]="loadingScreen"
    [ngTemplateOutletContext]="{
      overlay: false,
      stepIndex: loadingStepIndex(),
      label: loadingLabel(),
    }"
  ></ng-container>
}

<ng-template
  #loadingScreen
  let-overlay="overlay"
  let-stepIndex="stepIndex"
  let-label="label"
>
  <div class="app-loading" [class.app-loading-overlay]="overlay">
    <img
      class="app-loading-logo"
      src="assets/images/logos/jfw_logo.png"
      alt="JFW logo"
    />
    <span class="app-loading-wordmark">Dealer<span> Portal</span></span>

    <div class="app-loading-progress">
      @for (step of loadingSteps; track step; let i = $index) {
        <span
          class="app-loading-segment"
          [class.done]="i < stepIndex"
          [class.active]="i === stepIndex"
        ></span>
      }
    </div>

    <span class="app-loading-label">{{ label }}</span>
  </div>
</ng-template>
